import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';
import { useShareTokenInput } from './useShareTokenInput';

interface UseArtistListeningScoreParams {
  artistId: string;
  date?: Date;
  rangeDays?: number;
  enabled?: boolean;
}

export const useArtistListeningScore = ({
  artistId,
  date,
  rangeDays,
  enabled = true,
}: UseArtistListeningScoreParams) => {
  const trpcMusicAPI = useTRPCAPI();
  const shareTokenInput = useShareTokenInput();
  return useTRPCQuery(
    trpcMusicAPI.artists.listeningScore.queryOptions(
      { artistId, date, rangeDays, ...shareTokenInput },
      { enabled: Boolean(artistId) && enabled }
    )
  );
};
